import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#f1c93b",
        secondary: "#3E3E3E",
        accent: "#C62828",
        error: "#C62828",
      },
    },
  },
});
